/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, ADSEC){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';

	const slider = () => {
		// サムネイル作成
		$('.company-showroom-slider').on('init', (event, slick, currentSlide, nextSlide) => {
			let slideItem = $('.company-showroom-slider li.slick-slide:not(.slick-cloned)');
			slideItem.each((idx, ele) => {
				let slideImg = slideItem.eq(idx).find('img:visible');
				let dot = $('.slick-dots li').eq(idx).find('button');
				let src = slideImg.attr('src');
				dot.append('<img src="'+ src +'">');
			});
		});
		$('.company-showroom-slider').slick({
			autoplay: true,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			speed: 1500,
			loop: true,
			arrows: false,
			dots: true,
			infinite: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			responsive: [{
				breakpoint: 1025,
				settings: {
					arrows: true,
					prevArrow: arrowPrev,
					nextArrow: arrowNext,
				}
			}]
		});
	};

	// ==============================================================================
	if($('.company-showroom-slider').length) {
		slider();
	}

})(window.jQuery, window.ADSEC);
